import { propagation } from '@opentelemetry/api'
import {
  CompositePropagator,
  W3CTraceContextPropagator,
} from '@opentelemetry/core'

import { DatadogPropagator } from './datadog-propagator'

export function registerDatadogPropagator(origin: string): void {
  propagation.disable()
  propagation.setGlobalPropagator(
    new CompositePropagator({
      propagators: [
        new W3CTraceContextPropagator(),
        new DatadogPropagator(origin),
      ],
    }),
  )
}
